import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import PropTypes, { string } from 'prop-types';
import { BAR_COLOR } from 'constants/dashboard';
import CustomTooltip from '../GraphHelper/CustomTooltip';
import CustomLegend from '../GraphHelper/CustomLegend';
import GraphNoData from '../../assets/images/graphNoData.png';
import './BarChartGraph.scss';

function BarChartGraph(props) {
  const { data, yAxislabel, barKeys, xAxisLabelLength, xDataKey } = props;
  const ellipsize = (str, maxLength) => {
    return str.length > maxLength ? `${str.slice(0, 15)}...` : str;
  };
  const getBarKey = () => {
    const barKeyArray = [];
    barKeys.map((key, i) =>
      barKeyArray.push(
        <Bar
          key={key}
          barCategoryGap="25%"
          dataKey={`${key}.value`}
          animationEasing="linear"
          legendType="circle"
          activeBar={false}
          barSize={40}
          name={key}
          fill={BAR_COLOR[i % BAR_COLOR.length]}
        />
      )
    );
    return barKeyArray;
  };

  return (
    <div className="bar-chart-graph">
      <ResponsiveContainer className="graph-main-container">
        {data.length > 0 ? (
          <BarChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }}
            barGap={0}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey={xDataKey}
              orientation="bottom"
              padding="gap"
              interval={0}
              fontSize="13px"
              dy={10}
              tickFormatter={(value) => ellipsize(value, xAxisLabelLength)}
              label={{
                value: 'Merchant ID',
                angle: -0,
                offset: -20,
                position: 'insideBottom',
                fill: 'black',
                fontSize: 15
              }}
              stroke="black" // Axis line & tick color
              tick={{ fill: 'black' }} // Tick label styling
              axisLine={{ stroke: 'black' }} // Explicitly set axis line color
              tickLine={{ stroke: 'black' }} // Tick mark line color
            />
            <YAxis
              label={yAxislabel}
              tick={false}
              axisLine
              stroke="black" // Axis line & tick color
            />
            <Tooltip cursor={false} content={<CustomTooltip />} />
            <Legend iconSize={15} content={<CustomLegend />} />
            {data.length > 0 && getBarKey()}
          </BarChart>
        ) : (
          <div className="graph-no-data">
            <img src={GraphNoData} width="320px" height="170px" alt="Seems like no data" />
          </div>
        )}
      </ResponsiveContainer>
    </div>
  );
}

BarChartGraph.propTypes = {
  data: PropTypes.instanceOf(Object),
  xDataKey: PropTypes.string,
  barKeys: PropTypes.arrayOf(string),
  yAxislabel: PropTypes.instanceOf(Object),
  xAxisLabelLength: PropTypes.number
};

BarChartGraph.defaultProps = {
  data: [],
  xDataKey: '',
  barKeys: [],
  yAxislabel: {},
  xAxisLabelLength: 10
};

export default BarChartGraph;
